module.exports = __webpack_public_path__ + "static/media/Acheive3.87348675.jpg";